import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Signin } from '../../pages/authSphere/signin/Signin';

export const AuthRoutes: React.FC = () => (
    <Routes>
        <Route path="/signin" element={<Signin />} />

        {<Route path="*" element={<Navigate to='/signin' />} />}
    </Routes>
);